import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import logo from './assets/chartmaxx-logo-single.png';
import video from './assets/ai-bg.mp4';
import ContactUs from './pages/contactus';
import AppBrief from './pages/appbrief';
import MainContent from './pages/maincontent';
import PrivacyPolicy from './pages/privacypolicy';
import './App.css';

function App() {
  return (
    <Router>
      <div className="landing-page">
        <video
          src={video}
          className="background-video"
          autoPlay
          muted
          loop
        />

        {/* Logo Section */}
        <header className="logo-header">
          <Link to="/"><img src={logo} alt="Logo" className="logo" /></Link>
          <nav className="navigation">
            <ul>
              <li><Link to="/">Download App</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </nav>
        </header>
        <Routes>
          <Route path="/app-brief" element={<AppBrief />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/" element={<MainContent />} />
        </Routes>
        <footer className="site-footer">
          <Link to="/app-brief">App Brief</Link>
        </footer>
      </div>
    </Router>
  );
}

export default App;
